export default {"src":"/_next/static/media/0xba100000625a3754423978a60c9317c58a424e3d.525f9ff9.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};